import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import styles from "./PrinterFriendlyBankTransferDetail.module.css";

type PrinterFriendlyBankTransferDetailListProps = {
  items: Record<string, string>;
};

export const PrinterFriendlyBankTransferDetailList = ({
  items,
}: PrinterFriendlyBankTransferDetailListProps) => {
  const { t } = useTranslation();

  if (typeof document === "undefined") {
    return null;
  }

  return createPortal(
    <div className={`print-portal ${styles.PrintContainer}`}>
      <div className={styles.Header}>Payment details</div>
      <div className={styles.List}>
        {Object.entries(items).map(([key, value], i) => (
          <div key={i}>
            <div className={styles.Row}>
              <div className={styles.Label}>
                {t(`deposit.payment_placement.bank_transfer.${key}`)}
              </div>
              <div className={styles.Value}>{value}</div>
            </div>
            {key === "reference_code" && (
              <div className={styles.ReferenceNote}>
                <div className={styles.NoteBody}>
                  {t(
                    "deposit.payment_placement.bank_transfer.reference_code_note"
                  )}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>,
    document.body
  );
};
